import { config, type Project } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { Switch } from '@/components/ui/Switch';
import { screenContextSearchStore } from '@/features/chat/screen-context-search.store';
import { userStore } from '@/stores/user.store';

type ScreenContextMenuItemProps = {
  draftId: string;
  selectedProject: Project | null;
};

export const ScreenContextMenuItem = observer(function ScreenContextMenuItem({
  draftId,
  selectedProject,
}: ScreenContextMenuItemProps) {
  if (!userStore.isInternalUser) return null;

  // The backend applies the project's setting over any per-chat choice
  const disabledByProject = Boolean(
    selectedProject?.disableScreenContextSearch
  );
  const screenContextSearchDisabled =
    disabledByProject ||
    (screenContextSearchStore.disabledByChat[draftId] ??
      config.chat.disable_screen_context_search);

  return (
    <DropdownMenu.Item
      role="menuitemcheckbox"
      aria-checked={screenContextSearchDisabled}
      disabled={disabledByProject}
      onSelect={(event) => {
        // Keep the menu open so the switch visibly flips
        event.preventDefault();
        screenContextSearchStore.set(draftId, !screenContextSearchDisabled);
      }}
    >
      <Icons.eyeOff className="opacity-75" />
      <span className="flex-1">Disable screen context</span>
      {/* The row handles the toggle, so the switch only shows its state */}
      <Switch
        checked={screenContextSearchDisabled}
        tabIndex={-1}
        aria-hidden
        className="pointer-events-none"
      />
    </DropdownMenu.Item>
  );
});
